import { useState } from "react";
import { useInputField } from "@edreamsodigeo/prisma-design-system";

import type {
  InputType,
  UseInputPasswordFieldReturn,
  UsePasswordInputFieldProps,
} from "../contract";

const usePasswordInputField = (
  props: UsePasswordInputFieldProps,
): UseInputPasswordFieldReturn => {
  const [type, setType] = useState<InputType>("password");

  const onClick = (): void => {
    setType((type) => (type === "password" ? "text" : "password"));
  };

  const { ...inputFieldProps } = useInputField({
    ...props,
    onReset: () => {},
  });

  return {
    ...inputFieldProps,
    inputProps: { ...inputFieldProps.inputProps, type },
    iconProps: {
      ...inputFieldProps.iconProps,
    },
    onClickIconVisibility: onClick,
  };
};

export default usePasswordInputField;
